import axios from 'axios';
import {
  GetNewsHeadlinesRequestType,
  GetNewsHeadlinesResponseType,
  GetNewsStoryResponseType,
} from '../types/news.type';
import moment from 'moment';
import { NEWS_DATE_FORMAT } from '../utils/constant';

import { apiBase } from './apiBase';
export const getHeadlines = ({
  token,
  limit,
  symbol,
  rics,
  region,
  sector,
  newsId,
  newsRT,
  frdate,
  todate,
}: GetNewsHeadlinesRequestType): Promise<GetNewsHeadlinesResponseType> => {
  return new Promise(async (resolve, reject) => {
    const params: GetNewsHeadlinesRequestType = {
      token: token,
      limit: limit,
      newsId: newsId,
      newsRT: newsRT,
    };
    if (symbol && symbol.trim() !== '') {
      params.symbol = symbol;
    } else if (rics && rics.trim() !== '') {
      params.rics = rics;
    }
    if (region && region.trim() !== '') {
      params.region = region;
    }
    if (sector && sector.trim() !== '') {
      params.sector = sector;
    }

    if (
      frdate &&
      moment(frdate, NEWS_DATE_FORMAT).format(NEWS_DATE_FORMAT) === frdate
    ) {
      params.frdate = frdate;
    }
    if (
      todate &&
      moment(todate, NEWS_DATE_FORMAT).format(NEWS_DATE_FORMAT) === todate
    ) {
      params.todate = todate;
    }

    axios
      .get(`${apiBase()}/newsheadline`, {
        params: params,
      })
      .then((res) => {
        if (res.data.data) {
          resolve(res.data.data);
        } else {
          resolve(undefined as any);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getNewsStory = (
  token: string,
  newsId: string,
  format: string = 'HTML',
): Promise<GetNewsStoryResponseType> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(`${apiBase()}/newsstory`, {
        params: { token: token, newsId: newsId, format: format },
      })
      .then((res) => {
        if (res.data.data) {
          resolve(res.data.data);
        } else {
          resolve(undefined as any);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
